import { AddIcon, CloseIcon, RepeatIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Text,
  HStack,
  Th,
  Table,
  Thead,
  Tr,
  Tbody,
  Td,
  List,
  ListItem,
  Spinner,
  Portal,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState, useRef, useCallback, useContext } from "react";
import { appRequest } from "routes";
import CustomInput from "components/common/customInput/CustomInput";
import { addNA, addNAObject, extractPercentageFromLabel, calculateVatAmountFromArray, customDecimalRoundSafe } from "../../common/function";
import {
  currencyOptions
} from "../../common/constant";
import { AppContext } from "AppProvider/AppContext";

const COMPANY_CODES = [
  "EBL", "EMX", "ENL", "ELPL", "ENZ", "EPC", "ESA", "EPE", "EPP", "EWPL", "EAU", "EPL", "EMN", "EPDR", "EUK", "EBT", "EMCT", "EUS", "AVL", "LPK", "MNPI", "MPI", "TII", "TIL", "TIM", "ZHL"
];

const companyOptions = [
  { label: "Avet Lifesciences Pvt Ltd (AVL)", value: "AVL" },
  { label: "Emcure Australia (EAU)", value: "EAU" },
  { label: "Emcure Brasil (EBL)", value: "EBL" },
  { label: "Gennova Biopharmaceutical (EBT)", value: "EBT" },
  { label: "Emcure Life Science Pvt L (ELPL)", value: "ELPL" },
  { label: "Emcutix Biopharmaceutical (EMCT)", value: "EMCT" },
  { label: "Emcure Pharmaceutical Men (EMN)", value: "EMN" },
  { label: "Emcure Mexico (EMX)", value: "EMX" },
  { label: "Emcure Nigeria Limited (ENL)", value: "ENL" },
  { label: "Emcure NZ Ltd (ENZ)", value: "ENZ" },
  { label: "EMCURE PHARMA CHILE S.P.A (EPC)", value: "EPC" },
  { label: "EMCURE PHARMACEUTICALS (EPDR)", value: "EPDR" },
  { label: "Emcure Pharma Peru S.A.C. (EPE)", value: "EPE" },
  { label: "Emcure Pharmaceuticals (EPL)", value: "EPL" },
  { label: "Emcure Pharma Philippines (EPP)", value: "EPP" },
  { label: "Emcure South Africa (ESA)", value: "ESA" },
  { label: "Emcure Pharma UK Ltd. (EUK)", value: "EUK" },
  { label: "Avet Pharma Labs Inc. (EUS)", value: "EUS" },
  { label: "Emcure Wellness Private (EWPL)", value: "EWPL" },
  { label: "Lazor Pharmaceuticals Ltd (LPK)", value: "LPK" },
  { label: "Mantra Pharma Inc (MNPI)", value: "MNPI" },
  { label: "Marcan Pharmaceuticals In (MPI)", value: "MPI" },
  { label: "Tillomed Italia S.R.L. (TII)", value: "TII" },
  { label: "Tillomed Malta Ltd (TIM)", value: "TIM" },
  { label: "Australia (EAU)", value: "EAU" }
];

const editableInputProps = {
  size: "sm",
  h: "36px",
  bg: "gray.50",
  borderRadius: "md",
  borderColor: "gray.300",
  _hover: { bg: "white", borderColor: "gray.400" },
  _focus: {
    borderColor: "blue.500",
    boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.3)",
  },
};

const emergingInvoiceTypeOptions = [
  { label: "KG - Vendor Credit Memo", value: "KG" },
  { label: "KR - Vendor Invoice", value: "KR" },
];

interface LineItem {
  profitCenter: any;
  costCenter: any;
  businessArea: any;
  internalOrder: any;
  remark: string;
  tdsTaxCode: any;
  drCrIndicator: string;
  lineNarration: string;
  glAccount: any;
  glDescription: string;
  glAmount: string | number;
  wctPercentage: any;
  wctAmount: string | number;
  vatPercentage: any;
  vatAmount: string | number;
  rowId: string;
  costCenterOptions?: any[];
  internalOrderOptions?: any[];
  businessAreaOptions?: any[];
}

interface EmergingFormProps {
  value: any;
  onChange: (updated: any) => void;
  workflowProcess?: any;
  showTds?: any;
  tdsFifthApproval?: any;
  disabledOtherUserField?: any;
  gstUser?: any;
  validationErrors?: Record<string, string>;
  item?: any
}

export default function EmergingForm({
  value = {},
  onChange,
  workflowProcess,
  disabledOtherUserField,
  validationErrors = {},
  item
}: EmergingFormProps) {
  const { accountDetails } = useContext(AppContext);
  const [form, setForm] = useState<any>({
    region: undefined,
    companyCode: null,
    buyerName: "",
    buyerGstIn: "",
    vendorGstIn: "",
    vendorCode: "",
    vendorName: "",
    vendorAddress: "",
    paymentTerm: "",
    paymentTermDesc: "",
    Invoice_Number: "",
    Invoice_Date: "",
    Grand_Total: "",
    invoiceType: null,
    currency: "",
    headerText: "",
    vendorText: "",
    file_name: "",
    inv_id: "",
    start_time: "",
    postingDate: "",
    roundOff: "0.00",
    lineItems: [
      {
        profitCenter: null,
        costCenter: null,
        businessArea: null,
        internalOrder: null,
        remark: "",
        tdsTaxCode: null,
        drCrIndicator: "",
        lineNarration: "",
        glAccount: null,
        glDescription: "",
        glAmount: "",
        wctPercentage: "",
        wctAmount: "",
        vatPercentage: "",
        vatAmount: "",
        rowId: Date.now().toString(),
      },
    ],
    ...value,
  });

  const [vendorSearch, setVendorSearch] = useState(value.vendorCode || "");
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [showVendorList, setShowVendorList] = useState(false);
  const [isVendorLoading, setIsVendorLoading] = useState(false);

  const [pcOptions, setPcOptions] = useState<any[]>([]);
  const [glOptions, setGlOptions] = useState<any[]>([]);
  const [taxOptions, setTaxOptions] = useState<any[]>([]);
  const [tdsTaxOptions, setTdsTaxOptions] = useState<any[]>([]);
  const [paymentTermOptions, setPaymentTermOptions] = useState<any[]>([]);
  
  useEffect(() => {
    const fetchPaymentTerms = async () => {
      try {
        const payload = {
          page: 1,
          limit: 1000,
        };
        const res: any = await appRequest("vendorPaymentTerm", "getAll", payload);
        if (res?.status === "success" && Array.isArray(res?.data?.data)) {
          const options = res.data.data.map((item: any) => ({
            label: item.paymentTermDesc ? `${item.paymentTerm} - ${item.paymentTermDesc}` : item.paymentTerm,
            value: item.paymentTerm,
            desc: item.paymentTermDesc || ""
          }));
          setPaymentTermOptions((prev) => {
            const merged = [...options];
            if (form.paymentTerm && !merged.find((o) => o.value === form.paymentTerm)) {
              merged.unshift({
                label: form.paymentTermDesc ? `${form.paymentTerm} - ${form.paymentTermDesc}` : form.paymentTerm,
                value: form.paymentTerm,
                desc: form.paymentTermDesc || ""
              });
            }
            return merged;
          });
        }
      } catch (error) {
        console.error("Error fetching payment terms", error);
      }
    };
    fetchPaymentTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [dynamicRegions, setDynamicRegions] = useState<any[]>([]);
  const [companyCodeOptions, setCompanyCodeOptions] = useState<any[]>(
    COMPANY_CODES.map(code => ({ label: companyOptions.find(c => c.value === code)?.label || code, value: code }))
  );
  const toast = useToast();

  const vendorContainerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const vendorTimerRef = useRef<NodeJS.Timeout | null>(null);

  const onChangeRef = useRef(onChange);
  const workflowProcessRef = useRef(workflowProcess);
  const lastFetchedCode = useRef("");
  const isInternalUpdating = useRef(false);


  console.log('item', item)

  useEffect(() => { onChangeRef.current = onChange; }, [onChange]);
  useEffect(() => { workflowProcessRef.current = workflowProcess; }, [workflowProcess]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!vendorContainerRef.current?.contains(event.target as Node) && !dropdownRef.current?.contains(event.target as Node)) {
        setShowVendorList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  console.log("form", value);
  const updateForm = useCallback((updates: any | ((prev: any) => any)) => {
    setForm((prev: any) => {
      const next = typeof updates === "function" ? updates(prev) : { ...prev, ...updates };

      // Calculate Round Off: Grand Total - Sum(glAmount + vatAmount - wctAmount) of all line items
      const totalLineItemsAmount = customDecimalRoundSafe(
        (next.lineItems || []).reduce((acc: number, item: any) => {
          const gl = parseFloat(String(item.glAmount || "0").replace(/,/g, ""));
          const vat = parseFloat(String(item.vatAmount || "0").replace(/,/g, ""));
          const lineTotal = (isNaN(gl) ? 0 : gl) + (isNaN(vat) ? 0 : vat);
          return acc + lineTotal;
        }, 0)
      );

      const grandTotal = parseFloat(String(next.Grand_Total || "0").replace(/,/g, ""));
      const calculatedRoundOff = ((isNaN(grandTotal) ? 0 : grandTotal) - totalLineItemsAmount).toFixed(2);
      next.roundOff = calculatedRoundOff;

      const cleanData = (obj: any) => {
        const { lineItems, ...rest } = obj;
        const cleanedItems = (lineItems || []).map((li: any) => {
          const { costCenterOptions, internalOrderOptions, businessAreaOptions, ...data } = li;
          return data;
        });
        return { ...rest, lineItems: cleanedItems };
      };
      const cleanedNext = cleanData(next);
      if (JSON.stringify(cleanData(prev)) !== JSON.stringify(cleanedNext)) {
        isInternalUpdating.current = true;
        onChangeRef.current(cleanedNext);
        setTimeout(() => { isInternalUpdating.current = false; }, 300);
      }
      return next;
    });
  }, []);

  const updateLineItem = useCallback((index: number, updates: Partial<LineItem>) => {
    updateForm((prev: any) => {
      const newLineItems = [...prev.lineItems];
      if (newLineItems[index]) newLineItems[index] = { ...newLineItems[index], ...updates };
      return { ...prev, lineItems: newLineItems };
    });
  }, [updateForm]);

  useEffect(() => {
    if (isInternalUpdating.current) return;
    setForm((prev: any) => ({ ...prev, ...value }));
    if (value.vendorCode !== undefined && value.vendorCode !== vendorSearch) setVendorSearch(value.vendorCode || "");
  }, [value]);

  useEffect(() => {
    const fetchRegions = async () => {
      if (!accountDetails?.profileId) return;
      try {
        const res: any = await appRequest("user", "getEmergingRegionsByUser", { profileId: accountDetails.profileId });
        if (res?.status === "success") {
          setDynamicRegions((res.data || []).map((item: any) => ({
            ...item,
            label: (item.label || "").split("-").slice(2).join("-") || item.label
          })));
        }
      } catch (err) { console.error(err); }
    };
    fetchRegions();
  }, [accountDetails?.profileId]);

  const fetchProfitCenterOptions = useCallback(async (isManual = false) => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!code) return;
    setIsOptionsLoading(true);
    try {
      const res: any = await appRequest("user", "masterFinancialApi", { type: "getProfitCenter", companyCode: code, ...workflowProcessRef.current });
      if (res?.status === "success") {
        const options = (res.data || []).map((pc: any) => ({ label: pc.profitCenter, value: pc.profitCenter }));
        setPcOptions(options);

        // Auto-select 0th index for all empty line items if approval length is 0
        if (item?.approval?.length === 0 && options.length > 0) {
          form.lineItems.forEach((li: any, idx: number) => {
            if (!li.profitCenter) {
              handleProfitCenterChange(idx, options[0]);
            }
          });
        }

        if (isManual) toast({ title: "Profit Center", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      }
    } catch (err) { console.error(err); } finally { setIsOptionsLoading(false); }
  }, [form.companyCode]);

  useEffect(() => {
    const fetchCompanyCodes = async () => {
      try {
        const buyerName = form.buyerName;
        const buyerGstIn = form.buyerGstIn;

        if (!buyerName && !buyerGstIn) return;

        const payload = {
          buyerName,
          buyerGstin: buyerGstIn,
          type: "getCompanyCode",
          ...workflowProcessRef.current,
        };
        const response: any = await appRequest("user", "masterFinancialApi", payload);
        if (response?.status === "success") {
          const options = (response?.data || []).map((item: any) => ({
            label: companyOptions.find(c => c.value === item)?.label || item,
            value: item,
          }));
          if (options.length > 0) {
            setCompanyCodeOptions(options);
            if (!form.companyCode) {
              updateForm({ companyCode: options[0] });
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCompanyCodes();
  }, [form.buyerName, form.buyerGstIn]);


  useEffect(() => {
    const fetchVendorData = async () => {
      const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
      const gstin = form.vendorGstIn;

      if (!code || !gstin) return;

      setIsVendorLoading(true);
      try {
        const payload = {
          companyCode: code,
          type: "getGstVendorCode",
          gstin,
          ...workflowProcessRef.current,
        };
        const res: any = await appRequest("user", "masterFinancialApi", payload);
        if (res?.status === "success" && Array.isArray(res?.data) && res.data.length > 0) {
          setVendorList(res.data);
          if (!form.vendorCode) {

            console.log('the vendor code are', form)
            const firstVendor = res.data[0];

            if (firstVendor.paymentTerm) {
              setPaymentTermOptions((prev) => {
                if (prev.find((p) => p.value === firstVendor.paymentTerm)) return prev;
                return [{
                  label: firstVendor.paymentTermDesc ? `${firstVendor.paymentTerm} - ${firstVendor.paymentTermDesc}` : firstVendor.paymentTerm,
                  value: firstVendor.paymentTerm,
                  desc: firstVendor.paymentTermDesc || ""
                }, ...prev];
              });
            }

            updateForm((prev: any) => ({
              ...prev,
              vendorCode: firstVendor.vendorCode || "",
              vendorName: firstVendor.supplierName || firstVendor.label || firstVendor.vendorName || "",
              vendorAddress: firstVendor.vendorAddress || "",
              paymentTerm: prev.paymentTerm || firstVendor.paymentTerm || "",
              paymentTermDesc: prev.paymentTermDesc || firstVendor.paymentTermDesc || ""
            }));
            setVendorSearch(firstVendor.vendorCode || "");
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsVendorLoading(false);
      }
    };
    fetchVendorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.companyCode, form.vendorGstIn]);

  const fetchGlOptions = useCallback(async (isManual = false) => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!code) return;
    setIsOptionsLoading(true);
    try {
      const res: any = await appRequest("user", "masterFinancialApi", { type: "getGlAccount", companyCode: code, ...workflowProcessRef.current });
      if (res?.status === "success") {
        setGlOptions((res.data || []).map((gl: any) => ({ label: `${gl.glAccount}-${gl.description}` || gl.glAccount || gl.label, value: gl.glCode || gl.glAccount || gl.value, description: gl.description || gl.glDescription || "" })));
        if (isManual) toast({ title: "GL Account", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      }
    } catch (err) { console.error(err); } finally { setIsOptionsLoading(false); }
  }, [form.companyCode]);

  const fetchTaxOptions = useCallback(async (isManual = false) => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!code) return;
    setIsOptionsLoading(true);
    try {
      const res: any = await appRequest("taxcode", "getAll", {
        page: 1,
        limit: 500,
        process: workflowProcessRef.current?.processName,
        companyCode: code,
      });
      if (res?.status === "success") {
        setTaxOptions(addNAObject(res?.data?.data || []));
        if (isManual) toast({ title: "Tax Code", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      } else {
        setTaxOptions(addNAObject([]));
      }
    } catch (err) { console.error(err); } finally { setIsOptionsLoading(false); }
  }, [form.companyCode]);

  const fetchTdsTaxOptions = useCallback(async (isManual = false) => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    const vendor = form.vendorCode;
    if (!code || !vendor) return;
    setIsOptionsLoading(true);
    try {
      const res: any = await appRequest("user", "masterFinancialApi", {
        type: "getTdsTaxCode",
        companyCode: code,
        vendorCode: vendor,
        ...workflowProcessRef.current
      });
      if (res?.status === "success") {
        setTdsTaxOptions((res.data || []).map((code: any) => ({
          label: code?.label,
          value: code?.tdsTaxCode
        })));
        if (isManual) toast({ title: "WCT/TDS Tax Code", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      } else {
        setTdsTaxOptions([]);
      }
    } catch (err) { console.error(err); } finally { setIsOptionsLoading(false); }
  }, [form.companyCode, form.vendorCode]);

  useEffect(() => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (code && code !== lastFetchedCode.current) {
      lastFetchedCode.current = code;
      fetchProfitCenterOptions(); fetchGlOptions(); fetchTaxOptions();
    }
  }, [form.companyCode, fetchProfitCenterOptions, fetchGlOptions, fetchTaxOptions]);

  useEffect(() => {
    if (form.companyCode && form.vendorCode) {
      fetchTdsTaxOptions();
    }
  }, [form.companyCode, form.vendorCode, fetchTdsTaxOptions]);

  useEffect(() => {
    if (vendorTimerRef.current) clearTimeout(vendorTimerRef.current);
    const trimmed = vendorSearch.trim();
    if (!trimmed || trimmed.length < 2 || trimmed === form.vendorCode) return;
    vendorTimerRef.current = setTimeout(async () => {
      setIsVendorLoading(true);
      try {
        const res: any = await appRequest("user", "masterFinancialApi", { type: "getVendorByName", vendorName: trimmed, companyCode: form.companyCode?.value, ...workflowProcessRef.current });
        if (res?.status === "success") setVendorList(res.data || []);
        setShowVendorList((res.data || []).length > 0);
      } catch (err) { console.error(err); } finally { setIsVendorLoading(false); }
    }, 600);
  }, [vendorSearch, form.vendorCode, form.companyCode]);

  const handleSelectVendor = (vendor: any) => {
    updateForm((prev: any) => ({ 
      ...prev,
      vendorCode: vendor.vendorCode || "", 
      vendorName: vendor.supplierName || vendor.label || "", 
      vendorAddress: vendor.vendorAddress || "",
      paymentTerm: prev.paymentTerm || vendor.paymentTerm || "",
      paymentTermDesc: prev.paymentTermDesc || vendor.paymentTermDesc || ""
    }));

    if (vendor.paymentTerm) {
      setPaymentTermOptions((prev) => {
        if (prev.find((p) => p.value === vendor.paymentTerm)) return prev;
        return [{
          label: vendor.paymentTermDesc ? `${vendor.paymentTerm} - ${vendor.paymentTermDesc}` : vendor.paymentTerm,
          value: vendor.paymentTerm,
          desc: vendor.paymentTermDesc || ""
        }, ...prev];
      });
    }

    setVendorSearch(vendor.vendorCode || "");
    setShowVendorList(false);
  };

  const fetchCostCenterOptions = async (index: number, prof: any, isManual = false) => {
    const pVal = typeof prof === "object" ? prof?.value : prof;
    const cVal = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!pVal || !cVal) return;
    try {
      const res: any = await appRequest("user", "masterFinancialApi", { type: "getCostCenter", companyCode: cVal, profitCenter: pVal, ...workflowProcessRef.current });
      if (res?.status === "success") {
const options = [
  ...(res.data || []).map((cc: any) => ({
    label: cc.costCenter,
    value: cc.costCenter,
  }))
];

updateLineItem(index, { costCenterOptions: options });
        // Auto-select 0th index if approval length is 0 and cost center is not set
        if (item?.approval?.length === 0 && options.length > 0 && !form.lineItems[index].costCenter) {
          handleCostCenterChange(index, options[0], pVal);
        }

        if (isManual) toast({ title: "Cost Center", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      }
    } catch (err) { console.error(err); }
  };

  const fetchBusinessAreaOptions = async (index: number, prof: any, cost: any, isManual = false) => {
    const pVal = typeof prof === "object" ? prof?.value : prof;
    const coVal = typeof cost === "object" ? cost?.value : cost;
    const cpVal = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!pVal || !coVal || !cpVal) return;
    try {
      const res: any = await appRequest("user", "masterFinancialApi", { type: "getBusinessArea", companyCode: cpVal, profitCenter: pVal, costCenter: coVal, ...workflowProcessRef.current });
      if (res?.status === "success") {
        const options = (res.data || []).map((ba: string) => ({ label: ba, value: ba }));
        updateLineItem(index, { businessAreaOptions: options });

        // Auto-select 0th index if approval length is 0 and business area is not set
        if (item?.approval?.length === 0 && options.length > 0 && !form.lineItems[index].businessArea) {
          updateLineItem(index, { businessArea: options[0] });
        }

        if (isManual) toast({ title: "Business Area", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      }
    } catch (err) { console.error(err); }
  };

  const fetchInternalOrderOptions = async (index: number, cp: any, pc: any, gl: any, ba: any, isManual = false) => {
    const cpVal = typeof cp === "object" ? cp?.value : cp;
    const pcVal = typeof pc === "object" ? pc?.value : pc;
    const glVal = typeof gl === "object" ? gl?.value : gl;
    if (!cpVal || !pcVal || !glVal) return;
    try {
      const res: any = await appRequest("user", "masterFinancialApi", { type: "getInternalOrder", companyCode: cpVal, glAccount: glVal, profitCenter: pcVal, ...workflowProcessRef.current });
      if (res?.status === "success") {
        updateLineItem(index, { internalOrderOptions: (res.data || []).map((io: string) => ({ label: io, value: io })) });
        if (isManual) toast({ title: "Internal Order", description: "Data fetched successfully", status: "success", duration: 2000, isClosable: true });
      }
    } catch (err) { console.error(err); }
  };

  const calcTaxAmount = (glAmt: any, pct: any): string => {
    const gl = parseFloat(String(glAmt || 0));
    const p = parseFloat(String(pct || 0));
    if (isNaN(gl) || isNaN(p) || p === 0) return "";
    return (gl * p / 100).toFixed(2);
  };

  const addLineItem = () => {
    const type = form.invoiceType?.value;
    const drCr = type === "KG" ? "C" : type === "KR" ? "D" : "";
    updateForm((prev: any) => ({
      ...prev,
      lineItems: [...prev.lineItems, { profitCenter: null, costCenter: null, businessArea: null, internalOrder: null, remark: "", tdsTaxCode: null, drCrIndicator: drCr, lineNarration: "", glAccount: null, glDescription: "", glAmount: "", wctPercentage: "", wctAmount: "", vatPercentage: "", vatAmount: "", rowId: Date.now().toString() + Math.random().toString(36).substr(2, 9), costCenterOptions: [], internalOrderOptions: [], businessAreaOptions: [] }]
    }));
  };

  const removeLineItem = (index: number) => {
    updateForm((prev: any) => prev.lineItems.length > 1 ? { ...prev, lineItems: prev.lineItems.filter((_: any, i: number) => i !== index) } : prev);
  };

  const handleProfitCenterChange = async (index: number, val: any) => {
    updateLineItem(index, { profitCenter: val, costCenter: null, businessArea: null, internalOrder: null, costCenterOptions: [], businessAreaOptions: [], internalOrderOptions: [] });
    if (val) {
      fetchCostCenterOptions(index, val);
      // Re-fetch internal order options if glAccount is already selected (profitCenter is required)
      const currentItem = form.lineItems[index];
      if (currentItem?.glAccount && form.companyCode) {
        fetchInternalOrderOptions(index, form.companyCode, val, currentItem.glAccount, currentItem.businessArea);
      }
    }
  };

  const handleCostCenterChange = async (index: number, val: any, profCenter?: any) => {
    const pc = profCenter || form.lineItems[index].profitCenter;
    updateLineItem(index, { costCenter: val, businessArea: null, businessAreaOptions: [] });
    if (val && pc) fetchBusinessAreaOptions(index, pc, val);
  };

  const handleGlAccountChange = async (index: number, val: any) => {
    const opt = glOptions.find(o => o.value === (val?.value || val));
    updateLineItem(index, { glAccount: val, glDescription: opt?.description || "", internalOrder: null, internalOrderOptions: [] });
    const item = form.lineItems[index];
    if (val && item.profitCenter && form.companyCode) fetchInternalOrderOptions(index, form.companyCode, item.profitCenter, val, item.businessArea);
  };

  return (
    <Box maxH="75vh" overflowY="auto" pr={3}>
      <Text fontSize="xs" fontWeight="bold" color="blue.600" mb={4} textTransform="uppercase">General Header Data</Text>
      <Grid gridTemplateColumns={"1fr 1fr 1fr"} gap={4}>
        <Tooltip label={validationErrors.region} isOpen={!!validationErrors.region} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="region" label="Region" type="select" isBoxSelect isRequired={true} value={form.region} onChange={(val: any) => updateForm({ region: val })} options={dynamicRegions} disabled={accountDetails?.level !== "level-1"} error={validationErrors.region} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.companyCode} isOpen={!!validationErrors.companyCode} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="companyCode" label="Company Code" type="select" isBoxSelect isRequired={true} value={form.companyCode} onChange={(val: any) => updateForm({ companyCode: val })} options={companyCodeOptions} disabled={disabledOtherUserField} error={validationErrors.companyCode} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.buyerName} isOpen={!!validationErrors.buyerName} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="buyerName" label="Buyer Name" value={form.buyerName || ""} onChange={(e: any) => updateForm({ buyerName: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} isRequired={true} error={validationErrors.buyerName} showError={true} /></Box>
        </Tooltip>
        <CustomInput name="buyerGstIn" label="Buyer GST" value={form.buyerGstIn || ""} onChange={(e: any) => updateForm({ buyerGstIn: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} isRequired={false} />
        <CustomInput name="vendorGstIn" label="Vendor GST" value={form.vendorGstIn || ""} onChange={(e: any) => updateForm({ vendorGstIn: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} isRequired={false} />
        <FormControl position="relative" ref={vendorContainerRef}>
          <FormLabel fontSize="sm" mb={2}>Vendor Code / Name</FormLabel>
          <HStack><Input {...editableInputProps} value={vendorSearch} onChange={(e) => setVendorSearch(e.target.value)} onFocus={() => { if (vendorList.length > 0 && vendorSearch.length >= 2) setShowVendorList(true); }} placeholder="Search..." isRequired={true} disabled={disabledOtherUserField} />{isVendorLoading && <Spinner size="xs" color="blue.500" />}</HStack>
          {showVendorList && (
            <Portal>
              <Box ref={dropdownRef} position="fixed" top={vendorContainerRef.current?.getBoundingClientRect().bottom} left={vendorContainerRef.current?.getBoundingClientRect().left} width={vendorContainerRef.current?.clientWidth || "300px"} zIndex={1500} bg="white" border="1px solid" borderColor="blue.200" borderRadius="md" boxShadow="2xl" maxH="250px" overflowY="auto">
                <List variant="unstyled">
                  {vendorList.length > 0 ? vendorList.map((v, i) => (
                    <ListItem key={i} px={3} py={3} borderBottom="1px solid" borderColor="gray.50" _hover={{ bg: "blue.50", cursor: "pointer" }} onMouseDown={(e) => { e.preventDefault(); handleSelectVendor(v); }}>
                      <Text fontSize="xs" fontWeight="bold" color="blue.700">{v.vendorCode || "N/A"}</Text>
                      <Text fontSize="2xs" color="gray.600">{v.supplierName || v.label || "N/A"}</Text>
                    </ListItem>
                  )) : <Box px={3} py={3}><Text fontSize="xs" color="gray.500">No vendors found.</Text></Box>}
                </List>
              </Box>
            </Portal>
          )}
        </FormControl>
        <CustomInput name="vendorName" label="Vendor Name" value={form.vendorName || ""} disabled={true} isRequired={true} />
        <CustomInput name="vendorAddress" label="Vendor Address" value={form.vendorAddress || ""} disabled={true} isRequired={true} />
        <CustomInput 
          name="paymentTerm" 
          label="Payment Term" 
          type="select"
          isBoxSelect
          options={paymentTermOptions}
          value={form.paymentTerm ? {
            label: form.paymentTermDesc ? `${form.paymentTerm} - ${form.paymentTermDesc}` : form.paymentTerm,
            value: form.paymentTerm
          } : null} 
          onChange={(val: any) => updateForm({ paymentTerm: val?.value || "", paymentTermDesc: val?.desc || (val?.label ? val.label.split(' - ')[1] : "") || "" })} 
          disabled={disabledOtherUserField && accountDetails?.level !== "admin"} 
        />
        <CustomInput name="paymentTermDesc" label="Payment Term Desc" value={form.paymentTermDesc || ""} onChange={(e: any) => updateForm({ paymentTermDesc: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <Tooltip label={validationErrors.Invoice_Number} isOpen={!!validationErrors.Invoice_Number} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="Invoice_Number" label="Invoice No." value={form.Invoice_Number || ""} onChange={(e: any) => updateForm({ Invoice_Number: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.Invoice_Number} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.Invoice_Date} isOpen={!!validationErrors.Invoice_Date} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="Invoice_Date" label="Invoice Date" type="date" value={form.Invoice_Date || ""} onChange={(e: any) => updateForm({ Invoice_Date: e.target.value })} isRequired={true} maxDate={new Date().toISOString().split("T")[0]} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.Invoice_Date} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.Grand_Total} isOpen={!!validationErrors.Grand_Total} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="Grand_Total" label="Grand Total" type="number" value={form.Grand_Total || ""} onChange={(e: any) => updateForm({ Grand_Total: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.Grand_Total} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.invoiceType} isOpen={!!validationErrors.invoiceType} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="invoiceType" label="Invoice Type" type="select" isBoxSelect isRequired={true} value={form.invoiceType} onChange={(val: any) => updateForm({ invoiceType: val })} options={emergingInvoiceTypeOptions} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.invoiceType} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.currency} isOpen={!!validationErrors.currency} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="currency" label="Currency" type="select" isBoxSelect isRequired={true} value={form.currency} onChange={(val: any) => updateForm({ currency: val })} options={addNA(currencyOptions)} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.currency} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.headerText} isOpen={!!validationErrors.headerText} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="headerText" label="Header Text" value={form.headerText || ""} onChange={(e: any) => updateForm({ headerText: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.headerText} showError={true} /></Box>
        </Tooltip>
        <Tooltip label={validationErrors.vendorText} isOpen={!!validationErrors.vendorText} placement="top" colorScheme="red">
          <Box w="100%"><CustomInput name="vendorText" label="Vendor Text" value={form.vendorText || ""} onChange={(e: any) => updateForm({ vendorText: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error={validationErrors.vendorText} showError={true} /></Box>
        </Tooltip>
      </Grid>
      <Divider mb={4} mt={4} />
      <Box mt={5}>
        <HStack justify="space-between" mb={5}><Text fontSize="lg" fontWeight="semibold" color="blue.700">Line Items</Text><Button size="sm" colorScheme="blue" leftIcon={<AddIcon />} onClick={addLineItem} display={disabledOtherUserField || !["level-1", "level-2", "admin"].includes(accountDetails?.level) ? "none" : undefined}>Add Line Item</Button></HStack>
        {form.lineItems.length > 0 ? (
          <Box borderWidth="1px" borderRadius="md" overflowX="auto">
            <Table variant="simple" size="sm" minW="100%">
              <Thead bg="gray.100" position="sticky" top={0} zIndex={1}>
                <Tr>
                  <Th minW="220px">Profit Center <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="220px">Cost Center <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="180px">Business Area <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="120px">Dr/Cr <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="300px">Line Narration <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="220px">GL Account <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="280px">GL Description</Th>
                  <Th minW="220px">Internal Order <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="250px">GL Amount <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="120px">WCT %</Th>
                  <Th minW="140px">WCT Amount</Th>
                  <Th minW="180px">VAT % <span style={{ color: "red" }}>*</span></Th>
                  <Th minW="140px">VAT Amount</Th>
                  <Th minW="220px">Remark <span style={{ color: "red" }}>*</span></Th>

                  <Th minW="70px" textAlign="center">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {form.lineItems.map((item: LineItem, index: number) => (
                  <Tr key={item.rowId || index} _hover={{ bg: "gray.50" }}>
                    <Td><HStack><CustomInput name={`pc-${index}`} type="select" isBoxSelect value={item.profitCenter} onChange={(val: any) => handleProfitCenterChange(index, val)} options={pcOptions} disabled={disabledOtherUserField} style={{ minWidth: "200px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchProfitCenterOptions(true)} isDisabled={isOptionsLoading || disabledOtherUserField} /></HStack></Td>
                    <Td><HStack><CustomInput name={`cc-${index}`} type="select" isBoxSelect value={item.costCenter} onChange={(val: any) => handleCostCenterChange(index, val)} options={[
  ...(item.costCenterOptions || []),
  { label: "NA", value: "NA" },
]} disabled={disabledOtherUserField || !item.profitCenter} style={{ minWidth: "200px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchCostCenterOptions(index, item.profitCenter, true)} isDisabled={isOptionsLoading || disabledOtherUserField || !item.profitCenter} /></HStack></Td>
                    <Td><HStack><CustomInput name={`ba-${index}`} type="select" isBoxSelect value={item.businessArea} onChange={(val: any) => updateLineItem(index, { businessArea: val })} options={[
  ...(item.businessAreaOptions || []),
  { label: "NA", value: "NA" },
]} disabled={disabledOtherUserField || !item.costCenter} style={{ minWidth: "160px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchBusinessAreaOptions(index, item.profitCenter, item.costCenter, true)} isDisabled={isOptionsLoading || disabledOtherUserField || !item.costCenter} /></HStack></Td>
                    <Td><CustomInput name={`dc-${index}`} type="select" isBoxSelect value={item.drCrIndicator} onChange={(val: any) => updateLineItem(index, { drCrIndicator: val })} options={[{ label: "Debit", value: "D" }, { label: "Credit", value: "C" }]} disabled={disabledOtherUserField} style={{ minWidth: "120px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.lineNarration || ""} onChange={(e) => updateLineItem(index, { lineNarration: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "300px" }} /></Td>
                    <Td width={250}><HStack><CustomInput name={`gl-${index}`} type="select" isBoxSelect value={item.glAccount} onChange={(val: any) => handleGlAccountChange(index, val)} options={glOptions} disabled={disabledOtherUserField} style={{ minWidth: "300px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchGlOptions(true)} isDisabled={isOptionsLoading || disabledOtherUserField} /></HStack></Td>
                    <Td><Input {...editableInputProps} value={item.glDescription || ""} disabled={true} style={{ minWidth: "280px" }} /></Td>
                    <Td><HStack><CustomInput name={`io-${index}`} type="select" isBoxSelect value={item.internalOrder} onChange={(val: any) => updateLineItem(index, { internalOrder: val })} options={item.internalOrderOptions || []} disabled={disabledOtherUserField || !item.glAccount || !item.profitCenter} style={{ minWidth: "200px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchInternalOrderOptions(index, form.companyCode, item.profitCenter, item.glAccount, item.businessArea, true)} isDisabled={isOptionsLoading || disabledOtherUserField || !item.glAccount || !item.profitCenter} /></HStack></Td>
                    <Td><Input {...editableInputProps} type="number" value={item.glAmount || ""} onChange={(e) => {
                      const glAmt = e.target.value;
                      const wctPct = extractPercentageFromLabel(item.wctPercentage?.label || item.wctPercentage || "");
                      const vatCodes = Array.isArray(item.vatPercentage?.taxCodes)
                        ? item.vatPercentage.taxCodes
                        : [extractPercentageFromLabel(item.vatPercentage?.label || item.vatPercentage || "")];

                      updateLineItem(index, {
                        glAmount: glAmt,
                        wctAmount: calcTaxAmount(glAmt, wctPct),
                        vatAmount: calculateVatAmountFromArray(glAmt, vatCodes)
                      });
                    }} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td>
                      <HStack>
                        <CustomInput
                          name={`wct-${index}`}
                          type="select"
                          isBoxSelect
                          value={item.wctPercentage}
                          onChange={(val: any) => {
                            const percentage =
                              val?.value === "NA" ? 0 : extractPercentageFromLabel(val?.label || "");

                            updateLineItem(index, {
                              wctPercentage: val,
                              wctAmount: calcTaxAmount(item.glAmount, percentage)
                            });
                          }}
                          options={[...tdsTaxOptions, { label: "NA", value: "NA" }]}
                          disabled={disabledOtherUserField}
                          style={{ minWidth: "120px" }}
                        />

                        <IconButton
                          aria-label="Refresh"
                          icon={<RepeatIcon />}
                          size="sm"
                          variant="ghost"
                          colorScheme="blue"
                          onClick={() => fetchTdsTaxOptions(true)}
                          isDisabled={isOptionsLoading || disabledOtherUserField}
                        />
                      </HStack>
                    </Td>
                    <Td><Input {...editableInputProps} value={item.wctAmount || ""} disabled={true} bg="gray.100" style={{ minWidth: "140px" }} /></Td>
                    <Td><HStack><CustomInput name={`vat-${index}`} type="select" isBoxSelect value={item.vatPercentage} onChange={(val: any) => {
                      const taxCodes = Array.isArray(val?.taxCodes) ? val.taxCodes : [extractPercentageFromLabel(val?.label || "")];
                      updateLineItem(index, { vatPercentage: val, vatAmount: calculateVatAmountFromArray(item.glAmount, taxCodes) });
                    }} options={taxOptions} disabled={disabledOtherUserField} style={{ minWidth: "180px" }} /><IconButton aria-label="Refresh" icon={<RepeatIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => fetchTaxOptions(true)} isDisabled={isOptionsLoading || disabledOtherUserField} /></HStack></Td>
                    <Td><Input {...editableInputProps} value={item.vatAmount || ""} disabled={true} bg="gray.100" style={{ minWidth: "140px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.remark || ""} onChange={(e) => updateLineItem(index, { remark: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "220px" }} /></Td>
                    <Td textAlign="center"><IconButton aria-label="Delete" icon={<CloseIcon />} size="sm" colorScheme="red" variant="ghost" onClick={() => removeLineItem(index)} isDisabled={form.lineItems.length === 1 || disabledOtherUserField} /></Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        ) : <Text textAlign="center" py={10}>No items</Text>}
      </Box>
    </Box>
  );
}
